import { render, staticRenderFns } from "./SVC00000.vue?vue&type=template&id=6f06a8e6&"
import script from "./SVC00000.vue?vue&type=script&lang=js&"
export * from "./SVC00000.vue?vue&type=script&lang=js&"
import style0 from "./SVC00000.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports